<script>
import Alert from './Alert'
import ClockPicker from './ClockPicker'
import ClassEditor from './ClassEditor'
import ScholarshipInfo from './ScholarshipInfo'
import ApplicationCheckout from './ApplicationCheckout'
import Login from './Login'
import ScholarshipApplicant from './ScholarshipApplicant'
import Paperwork from './Paperwork'
import ClassPicker from './ClassPicker'
import ScholarshipOffer from './ScholarshipOffer'
import FirstTime from './FirstTime'
import StudentNote from './StudentNote'
import CreateGuardian from './CreateGuardian'
import CreateStudent from './CreateStudent'
import PasswordReset from './PasswordReset'
import StudentDetails from './StudentDetails'
import Invoice from './Invoice'
import PayInvoice from './PayInvoice'
import CreateClass from './CreateClass'
import CreateDiscountCode from './CreateDiscountCode'
import GiftCard from './GiftCard'
import RedemptionList from './RedemptionList'
export default {
  name: 'ModalsMain',
  components: {
    'alert': Alert,
    'clock-picker': ClockPicker,
    'class-editor': ClassEditor,
    'scholarship-info': ScholarshipInfo,
    'application-checkout': ApplicationCheckout,
    'login': Login,
    'scholarship-applicant': ScholarshipApplicant,
    'paperwork': Paperwork,
    'class-picker': ClassPicker,
    'scholarship-offer': ScholarshipOffer,
    'first-time': FirstTime,
    'student-note': StudentNote,
    'create-guardian': CreateGuardian,
    'create-student': CreateStudent,
    'password-reset': PasswordReset,
    'student-details': StudentDetails,
    'invoice': Invoice,
    'pay-invoice': PayInvoice,
    'create-class': CreateClass,
    'create-discount-code': CreateDiscountCode,
    'gift-card': GiftCard,
    'redemption-list': RedemptionList,
  },
  data () {
    return {
      modalsOptions: {},
    }
  },
  computed: {
    componentsList () {
      return Object.keys(this.$options.components).filter(comp => comp !== 'ModalsMain')
    },
  },
  methods: {
    shouldIncludeComp (comp) {
      return Object.keys(this.modalsOptions).includes(comp)
    },
    dictateBodyScroll () {
      const shouldScroll = !Object.keys(this.modalsOptions).length
      document.querySelector('body').style.overflow = shouldScroll ? 'scroll' : 'hidden'
    },
    setUpListeners () {
      this.$proOn('showModal', options => {
        if (options && this.componentsList.includes(options.name)) {
          this.modalsOptions[options.name] = options
          this.$forceUpdate()
        } else {
          alert(`Could not find and show the following modal: ${options && options.name}`)
        }
        this.dictateBodyScroll()
      })
      this.$proOn('hideModal', modalName => {
        // hides all modals if no modal name is declared
        if (!modalName) {
          this.modalsOptions = {}
        } else {
          delete this.modalsOptions[modalName]
        }
        this.$forceUpdate()
        this.dictateBodyScroll()
      })
    },
    onOverlayClick (comp) {
      if (this.modalsOptions[comp].hardClose) return
      this.$modals.hide(comp)
    },
  },
  mounted () {
    this.setUpListeners()
  },
}
</script>

<template lang="pug">
  span
    transition(
      name='fade'
    )
      .modals-main(
        v-if='Object.keys(this.modalsOptions).length'
      )
        .modals-container(
          v-for='(comp, idx) in componentsList'
          v-if='shouldIncludeComp(comp)'
          @click='onOverlayClick(comp)'
          )
            span(
              @click.stop=''
            )
              component(
                :is='comp'
                :options='modalsOptions[comp]'
                :style=`{'z-index': modalsOptions[comp].zIndex || 1}`
                )
</template>

<style lang="sass">
  @import '$styles/transitions.sass'
  .modals-main
    height: 100vh
    width: 100vw
    position: fixed
    z-index: $modals-index
    .modals-container
      height: 100%
      width: 100%
      background-color: transparentize(grey, .5)
      position: relative
      > span
        > .modal-main
          background-color: white
          position: absolute
          left: 50%
          top: 50%
          transform: translateY(-50%) translateX(-50%)
          height: auto
          max-height: 95vh
          width: calc(95% - 30px)
          max-width: 440px
          border-radius: 10px
          box-shadow: 0 0 15px 0 grey
          border: thin grey solid
          overflow-y: scroll
          > .modal-container
            > *
              padding: 15px
            > .title
              font-size: 1.2em
              color: white
              @extend .cs-gradient
              &.exit
                &:after
                  font-family: 'Material Icons'
                  content: 'highlight_off'
                  font-size: 36px
                  position: absolute
                  right: .5rem
                  top: .5rem
                  color: black
                  cursor: pointer
            > .content
              .pro-form
                .form-row
                  margin-bottom: 15px
                  .pro-input-main
                    .pro-input-container
                      .input-holder
                        .placeholder
                          font-size: 14px
                          &.active
                            font-size: 12px
                        > input
                          font-size: 14px
              .content-title
                font-family: $font-2
                font-size: 18px
              .explain
                font-color: $darkgrey
                font-size: 12px
              .input-field
                margin-top: 5px
                $input-font-size: .9em
                > input
                  margin-bottom: 8px
                  height: 2.6rem
                label
                  &.active
                    transform: translateY(-8px) scale(0.8)
            > .action
              @extend .cs-gradient
              color: white
              display: grid
              > *
                display: grid
              .button
                padding: 8px 5px
                border-radius: 500px
                color: white
                text-align: center
                cursor: pointer
                border: white 2px solid
                transition: all .25s
                user-select: none
                display: grid
                align-items: center
                &.minor
                  border: none
                  &:hover
                    background-color: transparent
                    color: white
                &:hover
                  color: $red
                  background-color: white
                &.cancel
                  background-color: transparent
                  border: none
                  color: white
</style>
